import { request } from "./apiClient";
import { assertSingleUploadSize } from "../lib/multipartUpload";

/**
 * Cài đặt hệ thống (singleton).
 * GET /settings — công khai; PUT & upload — cần Bearer admin.
 */
export const settingService = {
  getSettings: () => request("/settings"),

  updateSettings: (token, payload) =>
    request("/settings", { method: "PUT", token, body: payload }),

  /**
   * field: logo | favicon | ogImage | background
   * multipart field name: file
   */
  uploadAsset: (token, field, file) => {
    // Endpoint này xử lý tệp ở server (không có đường multipart) → chặn sớm tệp > 4MB với thông báo rõ ràng
    try {
      assertSingleUploadSize(file);
    } catch (e) {
      return Promise.reject(e);
    }
    const fd = new FormData();
    fd.append("file", file);
    return request(`/settings/assets/${encodeURIComponent(field)}`, {
      method: "POST",
      token,
      body: fd,
      isFormData: true,
    });
  },
};
